module.exports = "## Bulk image compressor\r\n\r\nUpload multiple images and compress them all at once using our image editor. You can choose a compression level or simply specify the maximum file size you want."


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/bulk-image-compressor.md
// module id = 1134
// module chunks = 0